<template>
    <div class="f-topic-reply">
        <!-- 置顶回复区 -->
        <div id="replyTopArea" class="f-topic-reply-top" v-if="hasStickyReply">
            <div class="f-topic-reply-head">
                <div class="f-topic-reply-head-blue"></div>
                <div class="f-topic-reply-head-word">置顶{{isBoardInfo}}</div>
            </div>
            <div class="f-topic-reply-toparea">
                <!-- 官方推荐回帖 -->
                <reply-list v-if="hasRecommendedReply"
                    :is-top="1"
                    :reply-info="recommendList"
                    @operate="operate">
                </reply-list>

                <!-- 采纳回帖 -->
                <reply-list v-if="hasAcceptedReply && !isSameReply"
                    :is-top="1"
                    :reply-info="acceptList"
                    @operate="operate">
                </reply-list>
            </div>
        </div>

        <!-- 普通回复区 -->
        <div v-if="replyCount"
            class="f-topic-reply-top"
            id="replyTop">
            <div class="f-topic-reply-head">
                <div class="f-topic-reply-head-blue"></div>
                <div class="f-topic-reply-head-word">{{isBoardInfo}}区</div>
            </div>
            <div class="f-topic-reply-info">
                <span class="f-topic-reply-info-num">共{{replyCount}}条{{isBoardInfo}}</span>
            </div>
            <div class="f-topic-reply-replylist">
                <reply-list v-for="item in replyList"
                    ref="childReplyList"
                    :key="item.replyId"
                    :reply-info="item"
                    @operate="operate">
                </reply-list>

                <!-- 翻页组件 -->
                <div class="f-topic-reply-replylist-page"
                    v-if="pageInfo.recordTotal > pageInfo.pageSize">
                    <page-component
                        class="f-topic-reply-replylist-page-form"
                        :pageInfo="pageInfo"
                    ></page-component>
                </div>
                <!-- 加载更多组件 -->
                <load-more class="f-topic-reply-replylist-page-more"
                    @load="load"
                    :pullUpState="pageInfo.pageNo < pageInfo.pageTotal ? 2 : 3"
                    selector-id="replyTop">
                </load-more>
            </div>

            <!-- 移动&小程序 不显示对 xxx 的回复 -->
            <div v-if="isPc && isReply" class="f-topic-reply-reply">
                <span>回复</span>
                <span v-if="replyFloor" class="f-topic-reply-reply-floor">#{{replyFloor}}</span>
                <span class="f-topic-reply-reply-border">·</span>
                <span>{{replyUser}}</span>
                <span class="f-topic-reply-reply-close" @click="cancelReply"></span>
            </div>
        </div>

        <!-- 回复编辑器 -->
        <div class="f-topic-reply-noReply" 
            id="replyBottom"
            :class="{'replyShow': isReplyShow}"
            @click="hideReplyModal">
            <editor-component ref="childEditor"
                class="f-topic-reply-editor"
                :editorid="'replyEditor'"></editor-component>
            <ui-button v-if="isLogin"
                text="提交回复"
                :loading="submitLoading"
                class="f-topic-reply-btn"
                @tapClick="submit">
            </ui-button>

            <div class="f-topic-reply-login-wrap" v-if="!isLogin">
                <div class="f-topic-reply-login">
                    <div class="f-topic-reply-login-btn" @click="navToPassport">登录</div>
                    <div class="f-topic-reply-login-word">点击登录后可发表评论</div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/views/topic-content/topic-reply.less';
</style>

<script>
/* global xaf getApp */
import ReplyList from './ReplyList.vue';
import LoadMore from '@/views/components/LoadMore.vue';

import Page from '@/views/components/page';
import Editor from '@/views/components/tinyEditor';
import Button from '@/components/ui-icon/button';

import {debounce, throttle} from '@/utils/debounceThrottle.js';
import toast from '@/utils/decorate/toast';
import {Tip} from '@/utils/errorCode';
import {mapState, mapGetters, mapMutations} from 'vuex';
import {scrollToId} from '@/utils/decorate/scroll';
import {getJt} from '@/utils/get-risk-info';

export default {
    components: {
        'reply-list': ReplyList,
        'page-component': Page,
        'load-more': LoadMore,
        'editor-component': Editor,
        'ui-button': Button
    },
    data() {
        return {
            isReply: false,
            replyFloor: -1,
            replyId: 0,
            replyUser: '',
            submitLoading: false,
            isBoardInfo: '' // 区分是为【回复】还是【回答】
        };
    },
    computed: {
        ...mapState({
            replyMaxLen: state => state.common.wordLimit.replyMaxLen,
            replyCount: state => state.topicContent.replyData.replyCount,
            replyList: state => state.topicContent.replyData.replyList1,
            pageInfo: state => state.topicContent.replyData.pageInfo1,
            topicId: state => state.topicContent.topicData.topicInfo.topicId,
            isSwan: state => state.common.isSwan,
            isPc: state => state.common.isPc,
            isLogin: state => state.header.isLogin,
            topicData: state => state.topicContent.topicData,
            isReplyShow: state => state.topicContent.isReplyShow,
            boardInfo: state => state.topicContent.topicData.boardInfo
        }),
        ...mapGetters([
            'hasStickyReply',
            'hasAcceptedReply',
            'hasRecommendedReply',
            'isSameReply'
        ]),
        recommendList() {
            if (this.hasRecommendedReply) {
                let id = this.topicData.ext.replyTopInfo.replyIds.recommend;
                return this.topicData.ext.replyTopInfo.replyList[id];
            }
            return {};
        },
        acceptList() {
            if (this.hasAcceptedReply) {
                let id = this.topicData.ext.replyTopInfo.replyIds.accept;
                return this.topicData.ext.replyTopInfo.replyList[id];
            }
            return {};
        }
    },
    created() {
        this.isBoardInfo = this.boardInfo.id === 1 ? '回答' : '回复';
    },
    methods: {
        ...mapMutations(['toggleReplyShow']),
        delReply(replyId) {
            this.$emit('showDelWindow', replyId);
        },
        cancelReply() {
            this.isReply = false;
        },
        replyTopic(replyFloor, replyId, nickname) {
            this.isReply = true;
            this.replyFloor = replyFloor;
            this.replyId = replyId;
            this.replyUser = nickname;
            this.toggleReplyShow(true);
            // 移动端&小程序 回复为弹窗 不支持滚动
            if (this.isPc) {
                scrollToId('replyBottom');
            }
        },
        navToPassport() {
            this.$store.dispatch('navToPassport');
        },
        submit: debounce(function () {
            this.toggleReplyShow(false);
            if (this.$store.state.header.isBanned) {
                toast.error(Tip.banned);
            }
            else if (this.isSwan) {
                this.swanSubmit();
            }
            else {
                this.webSubmit();
            }
        }),

        /**
             * 隐藏回复弹出层
             *
             * @description 因 mpvue 不支持.self 修饰符，只能通过判断 e.target 的方法
             * @param {Object} e 事件对象
             */
        hideReplyModal(e) {
            if (e.target.id && e.target.id === 'replyBottom') {
                this.toggleReplyShow(false);
            }
        },
        load: throttle(function (type, isPageTurn) {
            if (type === 'more') {
                this.loadMore();
            }
            else {
                this.loadLess(isPageTurn);
            }
        }),
        loadMore() {
            let params;
            let query;
            if (this.isSwan) {
                query = {topicId: this.topicId};
            }
            else {
                params = Object.assign({}, this.$route.params);
                query = Object.assign({}, this.$route.query);
                query.topicId = +params.topicid;
            }
            this.$store.dispatch('getReplyContent', {query, loadMore: true});
        },
        
        /**
         * web提交数据
         */
        webSubmit() {
            _hmt.push(['_trackEvent', 'operation', '回复按钮点击']);
            let content = this.$refs.childEditor.getContent();
            let pureText = this.$refs.childEditor.getText();
            // 纯文本为空，但不拦住纯图片
            if (pureText.length === 0 && content.indexOf('img') === -1) {
                toast.info(Tip.existNull);
            }
            else {
                let p = /<\/?.+?\/?>/g;
                let textLen = content.replace(p, matched => '').length;
                // 回复输入超过20000
                if (textLen > this.replyMaxLen) {
                    toast.info(`请输入不超过${this.replyMaxLen}个字符`);
                }
                else {
                    // 获取风控参数，每次提交时调用如下接口获取to和vw，不提前获取
                    const {Token: to, view: vw} = xaf.getData();
                    const biz = {
                        'content': pureText.slice(0, 100),
                        'topicId': this.topicId.toString(),
                        'ev': 'replyAdd'
                    };
                    getJt(biz).then(jt => {
                        let params = {
                            topicId: this.topicId,
                            content,
                            to,
                            vw,
                            jt,
                            biz
                        };
                        if (this.isReply) {
                            params.replyId = this.replyId;
                        }
                        this.submitLoading = true;

                        this.$store.dispatch('submitReplyInfo', params)
                            .then(() => {
                                this.submitLoading = false;

                                this.$refs.childEditor.setContent('');
                                this.isReply = false;
                                this.$store.dispatch('getReplyContent', {query: {topicId: params.topicId}})
                                    .then(() => scrollToId('replyTop'));
                            })
                            .catch(errmsg => {
                                toast.error(errmsg);
                                this.submitLoading = false;
                            });
                    });
                }
            }
        },
        loadLess(isPageTurn) {
            let name = this.$route.name;
            let params = Object.assign({}, this.$route.params);
            let query = Object.assign({}, this.$route.query);
            // 如果是翻页组件，获取当前数据的页码
            if (isPageTurn) {
                // 页码相同不触发 watch，手动请求接口
                if (+query.pageNo === +this.pageInfo.pageNo) {
                    query.topicId = this.topicId;
                    this.$store.dispatch('getReplyContent', {query, loadMore: false});
                    return;
                }
                query.pageNo = this.pageInfo.pageNo;
                this.$router.push({name, params, query});
            }
            // 如果是loadMore组件，数据从首页开始
            else {
                query.topicId = this.topicId;
                query.pageNo = 1;
                this.$store.dispatch('getReplyContent', {query, loadMore: false});
            }
        },
        swanSubmit() {
            let content = this.$refs.childEditor.getContent();
            // 获取风控参数，每次提交时调用如下接口获取to和vw，不提前获取
            const {Token: to, view: vw} = getApp().globalData.antifraud.getData();
            if (!content.length) {
                toast.info(Tip.existNull);
                return;
            }
            // 回复输入超过20000
            if (content.length > this.replyMaxLen) {
                toast.info(`请输入不超过${this.replyMaxLen}个字符`);
                return;
            }
            let params = {
                topicId: this.topicId,
                content,
                to,
                vw
            };
            if (this.isReply) {
                params.replyId = this.replyId;
            }
            this.$store.dispatch('submitReplyInfo', params)
                .then(() => {
                    this.$refs.childEditor.setContent('');
                    this.isReply = false;
                    this.$store.dispatch('getReplyContent', {query: {topicId: this.topicId}})
                        .then(() => {
                            if (this.isSwan) {
                                // 问题：回复新回复后，列表底部回复信息不渲染
                                // 因刷新对象信息 子组件监听不到 组件没有重新渲染
                                // 解决：通过 if 的判断条件，强制刷新回复列表
                                let count = this.replyCount;
                                this.$store.commit('changeReplyCount', 0);
                                this.$nextTick(() => {
                                    this.$store.commit('changeReplyCount', count);
                                });
                            }
                        });
                })
                .catch(errmsg => toast.error(errmsg));
        },
        operate({type, query}) {
            if (type === 'reply') {
                this.replyTopic(query.floor, query.replyId, query.userName);
            }
            if (type === 'toast') {
                this.$emit('openConfirmToast', {
                    type: query.type,
                    replyId: query.replyId
                });
            }
        }
    }
};
</script>

